module.exports = "//static.hsappstatic.net/codemirror/static-5.65/codemirror.css"